/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateIncidentInvestigationLockRequest
 */
export interface CreateIncidentInvestigationLockRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateIncidentInvestigationLockRequest
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateIncidentInvestigationLockRequest
     */
    personGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateIncidentInvestigationLockRequest
     */
    incidentId?: string;
}

/**
 * Check if a given object implements the CreateIncidentInvestigationLockRequest interface.
 */
export function instanceOfCreateIncidentInvestigationLockRequest(value: object): value is CreateIncidentInvestigationLockRequest {
    return true;
}

export function CreateIncidentInvestigationLockRequestFromJSON(json: any): CreateIncidentInvestigationLockRequest {
    return CreateIncidentInvestigationLockRequestFromJSONTyped(json, false);
}

export function CreateIncidentInvestigationLockRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIncidentInvestigationLockRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'personGoldenId': json['personGoldenId'] == null ? undefined : json['personGoldenId'],
        'incidentId': json['incidentId'] == null ? undefined : json['incidentId'],
    };
}

export function CreateIncidentInvestigationLockRequestToJSON(json: any): CreateIncidentInvestigationLockRequest {
    return CreateIncidentInvestigationLockRequestToJSONTyped(json, false);
}

export function CreateIncidentInvestigationLockRequestToJSONTyped(value?: CreateIncidentInvestigationLockRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'personGoldenId': value['personGoldenId'],
        'incidentId': value['incidentId'],
    };
}

